// ========== Custom error classes used within web register. ========== //
/**
 * Error thrown when offline mode is encountered with insufficient state (i.e. incomplete sync or no logged in user).
 *
 * @module webregister.constants.InsufficientStateForOfflineError
 */
export class InsufficientStateForOfflineError extends Error {
  constructor(...args: $TSFixMe[]) {
    super(...args)
    this.name = 'InsufficientStateForOfflineError'
  }
}

/**
 * Error thrown when a sync is interrupted.
 *
 * @module webregister.constants.SyncInterruptedError
 */
export class SyncInterruptedError extends Error {
  constructor(...args: $TSFixMe[]) {
    super(...args)
    this.name = 'SyncInterruptedError'
  }
}
